// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R404RouteImport } from './routes/404'
import { Route as AboutIndexRouteImport } from './routes/about/index'
import { Route as CareersIndexRouteImport } from './routes/careers/index'
import { Route as ContactIndexRouteImport } from './routes/contact/index'
import { Route as LegalIndexRouteImport } from './routes/legal/index'
import { Route as NewsIndexRouteImport } from './routes/news/index'
import { Route as NewsSplatRouteImport } from './routes/news/$'
import { Route as ServicesIndexRouteImport } from './routes/services/index'
import { Route as TeamIndexRouteImport } from './routes/team/index'
import { Route as CareersSlugIndexRouteImport } from './routes/careers/$slug/index'
import { Route as LegalSlugIndexRouteImport } from './routes/legal/$slug/index'
import { Route as LegalPoliciesSlugIndexRouteImport } from './routes/legal/policies/$slug/index'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const R404Route = R404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/about/',path: '/about/',getParentRoute: () => rootRouteImport
          })
const CareersIndexRoute = CareersIndexRouteImport.update({
            id: '/careers/',path: '/careers/',getParentRoute: () => rootRouteImport
          })
const ContactIndexRoute = ContactIndexRouteImport.update({
            id: '/contact/',path: '/contact/',getParentRoute: () => rootRouteImport
          })
const LegalIndexRoute = LegalIndexRouteImport.update({
            id: '/legal/',path: '/legal/',getParentRoute: () => rootRouteImport
          })
const NewsIndexRoute = NewsIndexRouteImport.update({
            id: '/news/',path: '/news/',getParentRoute: () => rootRouteImport
          })
const NewsSplatRoute = NewsSplatRouteImport.update({
            id: '/news/$',path: '/news/$',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const TeamIndexRoute = TeamIndexRouteImport.update({
            id: '/team/',path: '/team/',getParentRoute: () => rootRouteImport
          })
const CareersSlugIndexRoute = CareersSlugIndexRouteImport.update({
            id: '/careers/$slug/',path: '/careers/$slug/',getParentRoute: () => rootRouteImport
          })
const LegalSlugIndexRoute = LegalSlugIndexRouteImport.update({
            id: '/legal/$slug/',path: '/legal/$slug/',getParentRoute: () => rootRouteImport
          })
const LegalPoliciesSlugIndexRoute = LegalPoliciesSlugIndexRouteImport.update({
            id: '/legal/policies/$slug/',path: '/legal/policies/$slug/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,R404Route: R404Route,NewsSplatRoute: NewsSplatRoute,AboutIndexRoute: AboutIndexRoute,CareersIndexRoute: CareersIndexRoute,ContactIndexRoute: ContactIndexRoute,LegalIndexRoute: LegalIndexRoute,NewsIndexRoute: NewsIndexRoute,ServicesIndexRoute: ServicesIndexRoute,TeamIndexRoute: TeamIndexRoute,CareersSlugIndexRoute: CareersSlugIndexRoute,LegalSlugIndexRoute: LegalSlugIndexRoute,LegalPoliciesSlugIndexRoute: LegalPoliciesSlugIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)